import { concat } from '../../helpers/common'

const MODULE_NAME = 'TOOLS/'

// PLOP_APPEND_PATTERN_ANCHOR_ACTION
export const GET_AI_MESSAGE = concat(MODULE_NAME, 'GET_AI_MESSAGE')
export const GET_AI_MESSAGE_CHUNK = concat(MODULE_NAME, 'GET_AI_MESSAGE_CHUNK')
export const GET_AI_MESSAGE_SUCCESS = concat(MODULE_NAME, 'GET_AI_MESSAGE_SUCCESS')
export const GET_AI_MESSAGE_FAILURE = concat(MODULE_NAME, 'GET_AI_MESSAGE_FAILURE')
export const CANCEL_GET_AI_MESSAGE = concat(MODULE_NAME, 'CANCEL_GET_AI_MESSAGE')
export const CANCEL_ALL_CONVERSATIONS = concat(MODULE_NAME, 'CANCEL_ALL_CONVERSATIONS')
export const SET_SELECTED_AI_CONVERSATION_ID = concat(MODULE_NAME, 'SET_SELECTED_AI_CONVERSATION_ID')
export const SET_IS_NEW_CHAT_MODE = concat(MODULE_NAME, 'SET_IS_NEW_CHAT_MODE')

export const GET_AI_CONVERSATIONS = concat(MODULE_NAME, 'GET_AI_CONVERSATIONS')
export const GET_AI_CONVERSATIONS_SUCCESS = concat(MODULE_NAME, 'GET_AI_CONVERSATIONS_SUCCESS')
export const GET_AI_CONVERSATIONS_FAILURE = concat(MODULE_NAME, 'GET_AI_CONVERSATIONS_FAILURE')
export const CLEAR_GET_AI_CONVERSATIONS = concat(MODULE_NAME, 'CLEAR_GET_AI_CONVERSATIONS')

export const GET_AI_CONVERSATION_MESSAGES = concat(MODULE_NAME, 'GET_AI_CONVERSATION_MESSAGES')
export const GET_AI_CONVERSATION_MESSAGES_SUCCESS = concat(MODULE_NAME, 'GET_AI_CONVERSATION_MESSAGES_SUCCESS')
export const GET_AI_CONVERSATION_MESSAGES_FAILURE = concat(MODULE_NAME, 'GET_AI_CONVERSATION_MESSAGES_FAILURE')
export const CLEAR_GET_AI_CONVERSATION_MESSAGES = concat(MODULE_NAME, 'CLEAR_GET_AI_CONVERSATION_MESSAGES')

export const GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS = concat(MODULE_NAME, 'GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS')
export const GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS_CHUNK = concat(
  MODULE_NAME,
  'GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS_CHUNK'
)
export const GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS_SUCCESS = concat(
  MODULE_NAME,
  'GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS_SUCCESS'
)
export const GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS_FAILURE = concat(
  MODULE_NAME,
  'GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS_FAILURE'
)
export const CLEAR_GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS = concat(
  MODULE_NAME,
  'CLEAR_GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS'
)
export const CANCEL_GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS = concat(
  MODULE_NAME,
  'CANCEL_GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS'
)

export const GET_CHANGE_HISTORY = concat(MODULE_NAME, 'GET_CHANGE_HISTORY')
export const GET_CHANGE_HISTORY_SUCCESS = concat(MODULE_NAME, 'GET_CHANGE_HISTORY_SUCCESS')
export const GET_CHANGE_HISTORY_FAILURE = concat(MODULE_NAME, 'GET_CHANGE_HISTORY_FAILURE')
export const CLEAR_GET_CHANGE_HISTORY = concat(MODULE_NAME, 'CLEAR_GET_CHANGE_HISTORY')

export const GET_SELECTORS = concat(MODULE_NAME, 'GET_SELECTORS')
export const GET_SELECTORS_SUCCESS = concat(MODULE_NAME, 'GET_SELECTORS_SUCCESS')
export const GET_SELECTORS_FAILURE = concat(MODULE_NAME, 'GET_SELECTORS_FAILURE')
export const CLEAR_SELECTORS = concat(MODULE_NAME, 'CLEAR_SELECTORS')

export const UPDATE_SELECTOR = concat(MODULE_NAME, 'UPDATE_SELECTOR')
export const UPDATE_SELECTOR_SUCCESS = concat(MODULE_NAME, 'UPDATE_SELECTOR_SUCCESS')
export const UPDATE_SELECTOR_FAILURE = concat(MODULE_NAME, 'UPDATE_SELECTOR_FAILURE')
export const CLEAR_UPDATE_SELECTOR = concat(MODULE_NAME, 'CLEAR_UPDATE_SELECTOR')

export const UPDATE_AI_CONVERSATION = concat(MODULE_NAME, 'UPDATE_AI_CONVERSATION')
export const UPDATE_AI_CONVERSATION_SUCCESS = concat(MODULE_NAME, 'UPDATE_AI_CONVERSATION_SUCCESS')
export const UPDATE_AI_CONVERSATION_FAILURE = concat(MODULE_NAME, 'UPDATE_AI_CONVERSATION_FAILURE')
export const CLEAR_UPDATE_AI_CONVERSATION = concat(MODULE_NAME, 'CLEAR_UPDATE_AI_CONVERSATION')

// PLOP_APPEND_PATTERN_ANCHOR_ACTION_CREATOR

// Get ai message
export function getAiMessage(params, requestId) {
  return { type: GET_AI_MESSAGE, params, requestId }
}

export function getAiMessageChunk(dataChunk) {
  return { type: GET_AI_MESSAGE_CHUNK, dataChunk }
}

export function getAiMessageSuccess(data, requestId) {
  return { type: GET_AI_MESSAGE_SUCCESS, data, requestId }
}

export function getAiMessageFailure(error, requestId) {
  return { type: GET_AI_MESSAGE_FAILURE, error, requestId }
}

export function cancelGetAiMessage(conversationId, requestId) {
  return { type: CANCEL_GET_AI_MESSAGE, conversationId, requestId }
}

export function cancelAllConversations() {
  return { type: CANCEL_ALL_CONVERSATIONS }
}

export function setSelectedAiConversationId(conversationId) {
  return { type: SET_SELECTED_AI_CONVERSATION_ID, conversationId }
}

// Get ai conversations
export function getAiConversations(
  params,
  loadOptions = {
    shouldClearExistingState: false
  }
) {
  return { type: GET_AI_CONVERSATIONS, params, loadOptions }
}

export function getAiConversationsSuccess(data) {
  return { type: GET_AI_CONVERSATIONS_SUCCESS, data }
}

export function getAiConversationsFailure(error) {
  return { type: GET_AI_CONVERSATIONS_FAILURE, error }
}

export function clearGetAiConversations() {
  return { type: CLEAR_GET_AI_CONVERSATIONS }
}

// Get ai conversation messages
export function getAiConversationMessages(
  params,
  loadOptions = {
    shouldClearExistingState: false
  }
) {
  return { type: GET_AI_CONVERSATION_MESSAGES, params, loadOptions }
}

export function getAiConversationMessagesSuccess(data, conversationId) {
  return { type: GET_AI_CONVERSATION_MESSAGES_SUCCESS, data, conversationId }
}

export function getAiConversationMessagesFailure(error, conversationId) {
  return { type: GET_AI_CONVERSATION_MESSAGES_FAILURE, error, conversationId }
}

export function clearGetAiConversationMessages() {
  return { type: CLEAR_GET_AI_CONVERSATION_MESSAGES }
}

// set is new chat mode
export function setIsNewChatMode(isNewChatMode) {
  return { type: SET_IS_NEW_CHAT_MODE, isNewChatMode }
}

// Get sponsor form industry suggestions
export function getSponsorFormIndustrySuggestions(params, requestId) {
  return { type: GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS, params, requestId }
}

export function getSponsorFormIndustrySuggestionsChunk(dataChunk) {
  return { type: GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS_CHUNK, dataChunk }
}

export function getSponsorFormIndustrySuggestionsSuccess(data) {
  return { type: GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS_SUCCESS, data }
}

export function getSponsorFormIndustrySuggestionsFailure(error) {
  return { type: GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS_FAILURE, error }
}

export function clearGetSponsorFormIndustrySuggestions() {
  return { type: CLEAR_GET_SPONSOR_FORM_INDUSTRY_SUGGESTIONS }
}

// Get updates history
export function getChangeHistory(params) {
  return { type: GET_CHANGE_HISTORY, params }
}

export function getChangeHistorySuccess(data) {
  return { type: GET_CHANGE_HISTORY_SUCCESS, data }
}

export function getChangeHistoryFailure(error) {
  return { type: GET_CHANGE_HISTORY_FAILURE, error }
}

export function clearGetChangeHistory() {
  return { type: CLEAR_GET_CHANGE_HISTORY }
}

export function getSelectors(params) {
  return { type: GET_SELECTORS, params }
}

export function getSelectorsSuccess(selectorsData) {
  return { type: GET_SELECTORS_SUCCESS, selectorsData }
}

export function getSelectorsFailure(error) {
  return { type: GET_SELECTORS_FAILURE, error }
}

export function clearSelectors() {
  return { type: CLEAR_SELECTORS }
}

export function updateSelector(params) {
  return { type: UPDATE_SELECTOR, params }
}

export function updateSelectorSuccess(selectorData) {
  return { type: UPDATE_SELECTOR_SUCCESS, selectorData }
}

export function updateSelectorFailure(error) {
  return { type: UPDATE_SELECTOR_FAILURE, error }
}

export function clearUpdateSelector() {
  return { type: CLEAR_UPDATE_SELECTOR }
}

// Update ai conversation
export function updateAiConversation(id, data) {
  return { type: UPDATE_AI_CONVERSATION, id, data }
}

export function updateAiConversationSuccess(id, data) {
  return { type: UPDATE_AI_CONVERSATION_SUCCESS, id, data }
}

export function updateAiConversationFailure(id, error) {
  return { type: UPDATE_AI_CONVERSATION_FAILURE, id, error }
}

export function clearUpdateAiConversation() {
  return { type: CLEAR_UPDATE_AI_CONVERSATION }
}
